import type { AllergyIntolerance } from "@medplum/fhirtypes";
import { ALLERGY_INTOLERANCE_COLLECTION_NAME } from "../../fhir";
import { createSubscriptionHook } from "./create-subscription-hook";

export const useAllergyIntoleranceSubscription = createSubscriptionHook<AllergyIntolerance>(
  "AllergyIntolerance",
  ALLERGY_INTOLERANCE_COLLECTION_NAME,
);
